import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Spinner } from '@guryou/html-components';
import { stateIsLoaded, useMyOrders } from '@guryou/redux';
import { ProfileIcon, CalendarIcon, PaymentCardIcon } from '@guryou/html-components';
import EditProfile from './EditProfile';
import PaymentHistory from './PaymentHistory';
import Reservations from './Reservations';

const Profile = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('profile');
  const myOrders = useMyOrders();
  const auth = useSelector(state => state.auth);

  const tabs = [
    { id: 'profile', label: t('PROFILE.accountInfo'), icon: ProfileIcon, component: <EditProfile /> },
    { id: 'reservations', label: t('PROFILE.myReservations'), icon: CalendarIcon, component: <Reservations myOrders={myOrders} /> },
    { id: 'payments', label: t('PROFILE.paymentHistory'), icon: PaymentCardIcon, component: <PaymentHistory myOrders={myOrders} /> },
  ];

  if (!stateIsLoaded(auth)) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen w-full">
      <header className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800">{t('PROFILE.title')}</h1>
        <p className="text-gray-500 mt-1">{t('PROFILE.subtitle')}</p>
      </header>

      <div className="mb-4 border-b border-gray-200">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center" role="tablist">
          {tabs.map(tab => (
            <li key={tab.id} className="mr-2" role="presentation">
              <button
                className={`inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg group ${
                  activeTab === tab.id
                    ? `border-[var(--feel-primary)] text-[var(--feel-primary)]`
                    : 'border-transparent hover:text-gray-600 hover:border-gray-300'
                }`}
                onClick={() => setActiveTab(tab.id)}
                role="tab"
                aria-controls={tab.id}
                aria-selected={activeTab === tab.id}
              >
                <tab.icon className={`w-5 h-5 mr-2 ${activeTab === tab.id ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'}`} />
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        {tabs.map(tab => (
          <div key={tab.id} className={`${activeTab === tab.id ? 'block' : 'hidden'}`} role="tabpanel" aria-labelledby={`${tab.id}-tab`}>
            {tab.component}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
